import React, { useState, useEffect } from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import ScientificCalculator from '../../components/ScientificCalculator/ScientificCalculator';
import RewardsSystem from '../../components/RewardsSystem/RewardsSystem';
import DailyStreak from '../../components/DailyStreak/DailyStreak';
import { FaCalculator, FaTrophy, FaFire, FaCrown } from 'react-icons/fa';
import './Competitions.css';

const Competitions = () => {
    const { isDarkMode } = useDarkMode();
    const [activeTab, setActiveTab] = useState('calculator');

    useEffect(() => {
        window.scrollTo(0, 0);
        
        // Add class to body to prevent scrollbar
        document.body.classList.add('competitions-page-active');
        
        // Check for hash parameters
        const hash = window.location.hash;
        if (hash === '#calculator') {
            setActiveTab('calculator');
        } else if (hash === '#rewards') {
            setActiveTab('rewards');
        } else if (hash === '#streak') {
            setActiveTab('streak');
        }
        
        // Cleanup function to remove class when component unmounts
        return () => {
            document.body.classList.remove('competitions-page-active');
        };
    }, []);

    const renderContent = () => {
        switch (activeTab) {
            case 'calculator':
                return <ScientificCalculator />;
            case 'rewards':
                return <RewardsSystem />;
            case 'streak':
                return <DailyStreak />;
            default:
                return <ScientificCalculator />;
        }
    };

    return (
        <div className={`competitions-page ${isDarkMode ? 'dark' : 'light'}`}>
            {/* Hero Section */}
            <div className="competitions-hero">
                <div className="hero-content">
                    <div className="hero-icon">
                        <FaCrown fs={100} style={{width: '80px', height: '80px', margin : "50px 0"}} />
                    </div>
                    <h1 className="hero-title">مسابقات وجوائز علمني</h1>
                    <p className="hero-subtitle">اكتشف أدواتنا المذهلة واجمع النقاط لتصبح خبيراً</p>
                </div>
                

            </div>

            {/* Navigation Tabs */}
            <div className="competitions-nav">
                <div className="nav-container">
                    <button 
                        className={`nav-tab ${activeTab === 'calculator' ? 'active' : ''}`}
                        onClick={() => setActiveTab('calculator')}
                    >
                        <div className="tab-icon">
                            <FaCalculator />
                        </div>
                        <span className="tab-text mb-2">الحاسبة العلمية</span>
                    </button>
                    
                    <button 
                        className={`nav-tab ${activeTab === 'rewards' ? 'active' : ''}`}
                        onClick={() => setActiveTab('rewards')}
                    >
                        <div className="tab-icon">
                            <FaTrophy />
                        </div>
                        <span className="tab-text">نظام المكافآت</span>
                    </button>
                    
                    <button 
                        className={`nav-tab ${activeTab === 'streak' ? 'active' : ''}`}
                        onClick={() => setActiveTab('streak')}
                    >
                        <div className="tab-icon">
                            <FaFire />
                        </div>
                        <span className="tab-text">التحدي اليومي</span>
                    </button>
                </div>
            </div>

            {/* Content Section */}
            <div className="competitions-content">
                <div className="content-container">
                    {renderContent()}
                </div>
            </div>

            {/* Features Section */}
            <div className="competitions-features">
                <div className="features-container">
                    <div className="feature-card">
                        <div className="feature-icon">
                            <FaCalculator />
                        </div>
                        <h3>حاسبة علمية متقدمة</h3>
                        <p>استخدم وظائف علمية متقدمة مثل الجذر التربيعي واللوغاريتمات</p>
                    </div>
                    
                    <div className="feature-card">
                        <div className="feature-icon">
                            <FaTrophy />
                        </div>
                        <h3>نظام مكافآت شامل</h3>
                        <p>اجمع النقاط وافتح الإنجازات الجديدة مع كل خطوة</p>
                    </div>
                    
                    <div className="feature-card">
                        <div className="feature-icon">
                            <FaFire />
                        </div>
                        <h3>تحدي يومي مستمر</h3>
                        <p>حافظ على التحدي اليومي وارفع مستواك تدريجياً</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Competitions; 